import { Component, inject, OnInit } from '@angular/core';
import { CommitteeAttachment, CommitteeMember } from 'app/core/model/entity-model';
import { AttachmentOverviewComponent } from 'app/executive/attachment-overview/attachment-overview.component';
import { DevExtremeModule } from 'devextreme-angular';
import validationEngine from 'devextreme/ui/validation_engine';
import _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from '../../core/core.module';

export class EmailMode {}

@Component({
    selector: 'app-email-dialog',
    templateUrl: './email-dialog.component.html',
    styleUrls: ['./email-dialog.component.scss'],
        standalone: true,
        imports: [DevExtremeModule],
})
export class EmailDialogComponent implements OnInit {
    modalRef = inject(BsModalRef);
    uow = inject(ArkUnitOfWork);
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    utility = inject(UtilityService);
    modalService = inject(BsModalService);

    result = new Subject<{ success: boolean; value?: any; memberIds?: number[] }>();
    emailMessage: any;
    attachments: CommitteeAttachment[] = [];
    mode: string;
    entity: any;
    to: string;
    subject: string;
    body: string;
    isNew: boolean;
    processing: boolean;
    members: any[];
    hideCommittee: boolean = false;
    hideAttachments: boolean = false;

    truncatedList = false;
    committees: any;
    selectedCommitteeId: number;

    uploadUrl: string;
    uploadHeader: any;

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        if (!this.emailMessage) {
            this.isNew = true;
            if (!this.hideCommittee) {
                this.emailMessage = this.uow.committeeAttachmentEmails.createEntity({
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                    to: this.to,
                    subject: this.subject,
                    body: this.body,
                });
                this.emailMessage.sentTo = this.to;
            } else {
                //used for sending invoice emails
                this.emailMessage = this.uow.messages.createEntity({
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                    to: this.to,
                    subject: this.subject,
                    body: this.body,
                });
            }
        } else {
            await this.getAttachments();
        }
        if (!this.hideCommittee) {
            (this.emailMessage as any).to = this.members.map((x) => x.person.email).join(',');
            this.emailMessage.sentTo = this.emailMessage.to;
            (this.emailMessage as any).subject = this.subject;
            (this.emailMessage as any).body = this.body;
            this.members = [];
            this.committees = this.uow.lookups.committees;
            await this.getCommitteeMembers();
        } else {
            (this.emailMessage as any).to = this.to;
        }
        await this.appInfo.pleaseWaitHide();
    }

    selectionChanged(e) {
        this.getCommitteeMembers();
    }

    async getCommitteeMembers() {
        let members = [];
        if (this.selectedCommitteeId === 1) members = _.uniqBy((await this.uow.getMembersByCommitteeIds([2, 3, 4])) as CommitteeMember[], 'personId');
        else members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
        this.members = _.sortBy(members, 'person.lastName');
        (this.emailMessage as any).to = this.members.map((x) => x.person.email);
    }

    async getAttachments() {
        // this.attachments = await this.uow.getAttachments(FileService.Mode.EmailMessage, this.emailMessage.id);
    }

    async save() {
        if (this.processing) return;
        this.processing = true;

        const success = this.valid();
        if (!success) {
            this.processing = false;
            return;
        }

        if (!this.hideAttachments) {
            this.attachments.forEach((attachment) => {
                const attachmentLink = this.uow.committeeAttachmentEmailLinks.createEntity({
                    emailId: this.emailMessage.id,
                    attachmentId: attachment.id,
                });
            });
        }
        let memberIds: any[];
        if (!this.hideCommittee) {
            memberIds = this.members.map((x) => x.personId);
        }
        this.emailMessage.sentTo = this.emailMessage.to;

        this.result.next({ success: true, value: this.emailMessage, memberIds: memberIds });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('emailDialogValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('emailDialogValidationGroup');
            return result.isValid;
        } else return false;
    }

    async cancel() {
        if (this.isNew) {
            this.uow.rollback();
            // this.emailMessage.entityAspect.setDeleted();
            // const attachments = await this.uow.getAttachments(FileService.Mode.EmailMessage, this.emailMessage.id, true);
            // attachments.forEach((attachment) => attachment.entityAspect.setDeleted());
            // await this.uow.commit([this.emailMessage, ...attachments]);
        } else {
            this.emailMessage.entityAspect.rejectChanges();
        }

        this.result.next({ success: false });
    }

    async addMinutes() {
        const modalRef = this.modalService.show(AttachmentOverviewComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
                committeeId: this.selectedCommitteeId,
            },
        });

        modalRef.content.result?.subscribe(async (result) => {
            if (!!result && result.success) {
                const attachmentList = result.value;
                const newAttachments = attachmentList.filter((attachment) => !this.attachments.some((existing) => existing.id === attachment.id));
                this.attachments = this.attachments.concat(newAttachments);
            }
            modalRef.hide();
            this.processing = false;
        });
    }

    remove(memberId: number) {
        this.members.splice(
            this.members.findIndex((x) => x.personId === memberId),
            1
        );
        const memberList = this.members.map((x) => x.person.email).join(',');
        this.emailMessage.to = memberList;
        this.emailMessage.sentTo = memberList;
        this.truncatedList = true;
    }


    async removeAttachment(attachmentId: number) {
        if (!attachmentId) return;
        this.attachments = this.attachments.filter((a) => a.id !== attachmentId);
    }

    async openReport(mode?: string) {
        if (mode?.toLowerCase() === 'invoice') await this.utility.printInvoice(this.entity.id);
        else await this.utility.printAgenda(this.entity.id);
    }

    addCouncilClerk() {
        this.emailMessage.cc = this.emailMessage.cc ? this.emailMessage.cc + ',' + this.uow.lookups.clerkEmail : this.uow.lookups.clerkEmail;
    }
}
